/* Advances.tsx
    Une page affichant la gestion des acomptes
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les acomptes
    Utilise l'API correspondante pour les opérations de données
*/

import { faMoneyBills } from '@fortawesome/free-solid-svg-icons';
import { AdvancesCrudCard } from 'features/advances/components/AdvancesCrudCard';
import PageHeader from 'layout/PageHeader';

export const Advances = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faMoneyBills}
			title="Acomptes"
			subtitle="Gérez les acomptes de vos clients"
		/>
		<AdvancesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
